// extracted by mini-css-extract-plugin
export var deliveryRow = "_p8-a";
export var fixedHeight = "_p8-4";
export var freightLogo = "_p8-9";
export var fullWidth = "_p8-3";
export var priceColumn = "_p8-5";
export var radioSelected = "_p8-7";
export var radioUnselected = "_p8-6";
export var selectedOption = "_p8-2";
export var selectedOptionContainer = "_p8-1";
export var selection = "_p8-0";
export var tallSkeletonText = "_p8-8";